import { FormControlLabel, List } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../../redux/types'
import CustomCheckbox from '../../../../../../shared/components/inputs/CustomCheckbox'
import SubtitleGrey from '../../../../../../shared/styles/SubtitleGrey'
import { IUser, ROLES } from '../../../../models/user'

interface ConfigTabProps {
  user: IUser
  handleInputChange: (inputName: string, value: any) => void
  handleToggleMenusClick: (value: number) => void
}

export function ConfigTab({ user, handleInputChange, handleToggleMenusClick }: ConfigTabProps) {
  const { t } = useTranslation(['global'])

  const { user: authUser } = useSelector((state: IRootState) => state.auth)

  return (
    <Grid container spacing={2}>
      <Grid xs={12} sm={6}>
        <SubtitleGrey variant="body1">{t('restrict-access')}</SubtitleGrey>
        <List>
          {authUser.menus.map((value: any) => (
            <CustomCheckbox
              key={value.id}
              onChange={(_: any) => handleToggleMenusClick(value.id)}
              checked={user.menus.includes(value.id)}
              text={value.name}
            />
          ))}
        </List>
      </Grid>

      {[ROLES.superAdmin, ROLES.admin].includes(authUser.role_id) && user.role_id !== ROLES.client && (
        <Grid xs={12} sm={6}>
          <SubtitleGrey variant="body1">{t('admin.people.can-verify')}</SubtitleGrey>
          <FormControlLabel
            id="checkbox-can-verify"
            control={
              <CustomCheckbox
                onChange={(e: any) => handleInputChange('can_verify', Number(e.target.checked))}
                checked={Boolean(user.can_verify)}
                text={t('active')}
              />
            }
            label={''}
          />
        </Grid>
      )}
    </Grid>
  )
}
